var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"dialog-btn",style:(_vm.customStyles),attrs:{"data-testid":"dialogBtn","text":"","loading":_vm.loading,"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }